import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarDay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11 0h2v2h2v13H1V2h2V0h2v2h6zm2 13V9H9v4z",
		clipRule: "evenodd"
	})
});
export default SvgCalendarDay;
